const VIEWPORT_CONTENT = 'width=device-width, initial-scale=1'

/**
 * Injects a meta viewport tag into the document head if one does not already exist.
 * If one does exist, we update its content.
 * This allows the page to be responsive on mobile devices.
 */
export function injectMetaViewportTag(): void {
  const existingMeta = document.querySelector('meta[name="viewport"]')
  if (existingMeta) {
    existingMeta.setAttribute('name', 'viewport')
    existingMeta.setAttribute('content', VIEWPORT_CONTENT)
  } else {
    const meta = document.createElement('meta')
    meta.setAttribute('name', 'viewport')
    meta.setAttribute('content', VIEWPORT_CONTENT)
    document.head.appendChild(meta)
  }
}
